import React from 'react';

const Bottom: React.FC = () => (
   <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 6.33325L8 10.3333L4 6.33325" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
   </svg>
);

export default Bottom;